<ng-container *ngIf="notification">
    <ds-notification
        theme="warning"
        [header]="'Warning - Trip ID ' + notification.TripId"
        [content]="
            notification.TripId +
            ' has a ' +
            notification.Category +
            ' flag that needs to be resolved by ' +
            (notification.FollowUpTime | date: 'MM/dd/yyyy, HH:mm a')
        "
        (viewClick)="onViewServiceRequest()"
        (dismissClick)="closeNotification()"
    ></ds-notification>
</ng-container>
